import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Label, { LabelProps } from 'components/Label';

import Styled from './styles';

interface TreeTitleProps extends LabelProps {
  /**
   * @ignore
   * To customize the style of wrapper.
   * */
  style?: React.CSSProperties;
  /** The content of TreeTitle */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Title of the Tree. Any other props will be provided to the Label component. */
const TreeTitle = React.forwardRef<HTMLElement, TreeTitleProps>((props: TreeTitleProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    theme: propTheme,
    style,
    ...otherProps
  } = props;
  const userTheme = propTheme && propTheme.TREE;
  const resolvedTheme = _merge({}, theme.TREE, userTheme);
  return (
    <Label
      verticalLayout
      ref={ref}
      style={{ padding: RTL ? '0.625rem 1rem  0 0' : '0.625rem 0 0 1rem', ...style }}
      {...otherProps}
    >
      <Styled.TreeLabelContent $theme={resolvedTheme}>
        {children}
      </Styled.TreeLabelContent>
    </Label>
  );
}));

TreeTitle.defaultProps = {
  style: {},
  theme: {}
};

TreeTitle.displayName = 'TreeTitle';

export { TreeTitle as default };
